// Deliberately separate from Tinode and the existing moments store. No network access.
export const demoAuthors = {
  studio: {name: 'Vibe Studio', username: 'vibe.studio', bio: 'Места, люди и маленькие открытия. Демонстрационный профиль.', followers: 1280, color: '#b6c1a1'},
  anna: {name: 'Анна', username: 'anna.creates', bio: 'Собираю свет и городские истории. Демонстрационный профиль.', followers: 846, color: '#b9aec5'},
  me: {name: 'Мой профиль', username: 'you', bio: 'Здесь начинается ваша история.', followers: 0, color: '#eeb38c'}
};
export function initialSocial() {
  return {version: 2, follows: [], profile: demoAuthors.me, posts: [
    {id: 'demo-clip', author: 'studio', kind: 'clip', text: 'Три секунды в своём ритме. Демонстрационный клип Vibe.', src: 'img/vibe-demo.mp4', likes: 32, comments: [], saved: false},
    {id: 'demo-1', author: 'studio', kind: 'post', text: 'Больше, чем разговор. Место для того, чем хочется поделиться.', art: 'sunset', likes: 128, comments: [], saved: false},
    {id: 'demo-2', author: 'anna', kind: 'post', text: 'Замедлиться. Заметить свет. Сохранить этот момент.', art: 'city', likes: 64, comments: [], saved: false}
  ]};
}
const open = () => new Promise((resolve, reject) => {
  const request = indexedDB.open('vibe-social-local-v1', 1);
  request.onupgradeneeded = () => request.result.createObjectStore('accounts');
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});
export async function socialStore(owner, value) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('accounts', value ? 'readwrite' : 'readonly');
    const store = tx.objectStore('accounts');
    const req = value ? store.put(value, owner) : store.get(owner);
    tx.oncomplete = () => {db.close(); const result = req.result || initialSocial();
      if (!value && result.version === 1) {result.posts.push(initialSocial().posts[0]);result.version=2;}
      resolve(result);};
    tx.onerror = tx.onabort = () => {db.close(); reject(tx.error || new Error('Хранилище недоступно'));};
  });
}
